var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-container" },
    [
      _c("vue-confirm-dialog"),
      _vm._v(" "),
      _c("IONotifications"),
      _vm._v(" "),
      _c("SettingsModal"),
      _vm._v(" "),
      _c("GlobalModal"),
      _vm._v(" "),
      _c("GlobalDrawer"),
      _vm._v(" "),
      _vm.isAllow("createClientRequest")
        ? _c("ClientsRequestButton")
        : _vm._e(),
      _vm._v(" "),
      _c("site-header", { attrs: { searchByMenu: _vm.searchUpdated } }),
      _vm._v(" "),
      _vm.usersRoles
        ? _c("site-sidebar", {
            attrs: {
              type: "basic",
              usersRoles: _vm.usersRoles,
              filterMenuByText: _vm.searchText,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.SideModalData && _vm.SideModalData.open
        ? _c("SideModal", { attrs: { data: _vm.SideModalData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderModalData.open
        ? _c("sideBarOrderModal", {
            attrs: {
              modalData: _vm.orderModalData,
              onModalClose: () => (this.orderModalData = {}),
              fetchOrders: () => {},
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.invoiceModalData.open
        ? _c("sideBarInvoiceModal", {
            attrs: {
              modalData: _vm.invoiceModalData,
              onModalClose: () => (this.invoiceModalData = {}),
              fetchOrders: () => {},
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("site-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }